<template>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>运营经理</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="success" @click="showOperator()">
              <el-icon><plus /></el-icon>新增运营经理
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="operators" border>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column label="佣金比例">
        <template #default="scope">
          {{scope.row.agentOpCommissionRate}}%
        </template>
      </el-table-column>
      <el-table-column prop="factoryNum" label="负责门店"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showOperator(scope.row)">修改</el-link>
          <el-link type="danger" href="javascript:;" @click="delOperator(scope.row)">删除</el-link>
          <el-link type="primary" href="javascript:;" :disabled="scope.row.openId" @click="showCode(scope.row)">绑定码</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="operator.sn ? '修改' : '新增'" v-model="saveOperatorVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="operator" ref="operator">
      <el-row :gutter="8">
        <el-col :span="8">
          <el-form-item label="手机号" label-width="78px">
            <el-input type="text" v-model="operator.phone" @blur="getUser" :readonly="operator.sn"></el-input>
          </el-form-item>
          <el-form-item label="姓名" label-width="78px">
            <el-input type="text" v-model="operator.name"></el-input>
          </el-form-item>
          <el-form-item label="佣金比例" label-width="78px">
            <el-input type="number" v-model="operator.agentOpCommissionRate">
              <template #append>%</template>
            </el-input>
            <div class="tips"><i>基于服务商佣金</i></div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-tree ref="unallocatedTree" :data="unallocated" show-checkbox node-key="sn" :default-expanded-keys="['0']" :default-checked-keys="checkedKeys" :props="customProps"/>
        </el-col>
        <el-col :span="8">
          <el-tree ref="allocatedTree" :data="allocated" show-checkbox node-key="sn" :default-expanded-keys="['0']" :props="customProps"/>
        </el-col>
      </el-row>
      <el-button type="primary" @click="saveOperator">确定</el-button>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "运营经理",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      total: 0,
      operators: [],
      operator: {},
      saveOperatorVisible: false,
      checkedKeys: [],
      unallocated: [],
      allocated: [],
      customProps: {
        children: 'factoryVOS',
        label: 'factoryName'
      }
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$apis.shopOperate.list(this.currentUser.sn, this.pageIndex - 1, this.pageSize).then(response => {
        this.operators = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list()
    },
    showOperator(operator) {
      this.operator = {}
      if (operator) {
        Object.assign(this.operator, operator)
      }
      this.saveOperatorVisible = true
      this.$apis.shopOperate.getShops(this.currentUser.sn).then(response => {
        let unallocated = response.data.unSetVOS
        let allocated = response.data.setVOS
        if (operator) {
          let index = allocated.findIndex(item => item.sn === operator.sn)
          if (index >= 0) {
            let org = allocated[index].factoryVOS
            unallocated = unallocated.concat(org)
            this.checkedKeys = org.map(item => item.sn)
            allocated.splice(index, 1)
          }
        }
        this.unallocated = [
          {
            sn: '0',
            factoryName: '待分配门店',
            factoryVOS: unallocated
          }
        ]
        allocated.forEach(item => item.factoryName = item.name)
        this.allocated = [
          {
            sn: '0',
            factoryName: '已分配门店',
            factoryVOS: allocated
          }
        ]
      })
    },
    saveOperator() {
      if (!this.operator.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.operator.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (this.operator.agentOpCommissionRate == null) {
        this.$message.error('请输入佣金比例')
        return
      }
      let unallocatedSns = this.$refs.unallocatedTree.getCheckedKeys(true)
      let allocatedSns = this.$refs.allocatedTree.getCheckedKeys(true)
      let sns = unallocatedSns.concat(allocatedSns)
      /*if (!sns || !sns.length) {
        this.$message.error('请选择门店')
        return
      }*/
      this.operator.factorySns = sns
      if (!this.operator.sn) {
        this.operator.agentSn = this.currentUser.sn
        this.$apis.shopOperate.add(this.operator).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveOperatorVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.shopOperate.edit(this.operator).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveOperatorVisible = false
            this.list()
          }
        })
      }
    },
    delOperator(operator) {
      this.$confirm('确认删除【' + operator.name + '】？', '删除确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.shopOperate.del(operator.sn).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    showCode(operator) {
      this.$alert(
          '<div style="text-align: center;">' +
          '<img src="' + this.$utils.imageSrc(operator.mipImage) + '" style="margin: 0 auto;display: block;width: 200px;"/>' +
          '<div style="margin-top: 6px;font-size: 16px;color: gray;">微信扫一扫</div>' +
          '<div style="margin-top: 3px;font-size: 14px;color: gray;">（' + operator.name + '）</div>' +
          '</div>',
          '绑定码', {dangerouslyUseHTMLString: true, showConfirmButton: false})
    },
    getUser() {
      if (!this.operator.sn && this.operator.phone) {
        this.$apis.common.getUser(this.operator.phone).then(response => {
          if (response.status === 200) {
            this.operator.name = response.data
          } else {
            this.operator.phone = ''
          }
        })
      }
    }
  },
  created() {
    this.list()
  }
}
</script>

<style scoped>

</style>